import { useEffect, useState } from "react";
import { IonSegment, IonSegmentButton } from "@ionic/react";
import { useAuth } from "pages";
import { BillingPage } from "pages/more";
import { useFeatureFlags } from "swing-components";

import { translate } from "~utils";

import { Budgets } from "./components/Budgets";
import { Insights } from "./components/Insights";

export function BillingPortalPage() {
  const { flags } = useFeatureFlags();

  const billingPortalTabs = [
    translate("BILLING_PORTAL_TAB_BUDGETS"),
    translate("BILLING_PORTAL_TAB_INVOICES"),
  ];

  if (flags.performanceInsights) {
    billingPortalTabs.unshift(translate("BILLING_PORTAL_TAB_INSIGHTS"));
  }

  const [tab, setTab] = useState(billingPortalTabs[0]);

  useEffect(() => {
    setTab(
      flags.performanceInsights
        ? translate("BILLING_PORTAL_TAB_INSIGHTS")
        : translate("BILLING_PORTAL_TAB_BUDGETS"),
    );
  }, [flags.performanceInsights]);

  const { userInfo } = useAuth();
  const showTabs = userInfo.isBillingAdmin || userInfo.isSuperAdmin;

  return (
    <div css={{ maxWidth: 900, padding: "0 16px", margin: "0 auto" }}>
      {showTabs && (
        <IonSegment
          css={{ width: "100%", display: "flex" }}
          value={tab}
          onIonChange={(e) => setTab(e.target.value as string)}
        >
          {billingPortalTabs.map((tab) => (
            <IonSegmentButton css={{ flex: "1 1 auto" }} value={tab} key={tab}>
              {tab}
            </IonSegmentButton>
          ))}
        </IonSegment>
      )}
      {/* TODO:  Move Billing Portal Page into `src/pages/components` */}
      {tab === translate("BILLING_PORTAL_TAB_INSIGHTS") && <Insights />}
      {tab === translate("BILLING_PORTAL_TAB_BUDGETS") && <Budgets />}
      {tab === translate("BILLING_PORTAL_TAB_INVOICES") && <BillingPage />}
    </div>
  );
}
